export default __webpack_public_path__ + "static/media/eye.29befece.svg";